import { useMutation } from '@tanstack/react-query';
import { ALERT_STATUS, useAlert } from '../../../contexts/AlertContext';

import { handleUpdateStatus } from '../../brandbooks';

const useUpdateStatus = (handleSuccess) => {
	const { handleAlert } = useAlert();

	const { mutate: handleUpdateBrandBookStatus, isPending } = useMutation({
		mutationFn: (data) => handleUpdateStatus(data),
		onSuccess: handleSuccess,
		onError: (error) => {
			handleAlert(ALERT_STATUS.ERROR, error.response.data.error);
		},
	});

	return { handleUpdateBrandBookStatus, isPending };
};

export default useUpdateStatus;
